
import { CLIENT } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }

    switch (action.type) {
        case CLIENT.DATA.INITIATE:
            return {isFetching: false};
        case CLIENT.DATA.SUCCESS:
            return {isFetching: true, data: action.payload};
        case CLIENT.DATA.ERROR:
            return {isFetching: true, data: action.payload};
        default:
            return state;
    }
};
